import { render, staticRenderFns } from "./generalTab.vue?vue&type=template&id=e0cb2a42&scoped=true&"
import script from "./generalTab.vue?vue&type=script&lang=js&"
export * from "./generalTab.vue?vue&type=script&lang=js&"
import style0 from "./generalTab.vue?vue&type=style&index=0&id=e0cb2a42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0cb2a42",
  null
  
)

export default component.exports